// extracted by mini-css-extract-plugin
module.exports = {"developedBy":"DevelopedBy_developedBy__4O654","companyName":"DevelopedBy_companyName__13SCL"};